import { lmsClient } from "api";

const GLAccountService = {};

function buildQuery(params) {
  return Object.entries(params)
    .filter(([_, v]) => v !== null && v !== undefined && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
}

GLAccountService.getGLAccounts = function (data = {}) {
  const dataIndex = data?.pageIndex || 0;
  const decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;

  const params = {
    pageSize: data.pageSize,
    pageIndex: decrementIndex,
    branchId: data?.branchId,
    glaccountid: data?.glaccountid,
    description: data?.description,
  };

  const query = buildQuery(params);

  return lmsClient({
    url: query ? `/lms/glAccount/search?${query}` : "/lms/glAccount/search",
    method: "get",
  });
};

export default GLAccountService;
